import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { commonLabels } from "@/i18n";

const HeroTitle = () => {
  const { language } = useLanguage();
  const labels = commonLabels(language);
  const heroData = labels.menuPages?.howItWorks?.hero || {};
  const title = heroData.title || "Hur Det";
  const titleHighlight = heroData.titleHighlight || "Fungerar";

  return (
    <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl 2xl:text-8xl font-bold mb-6 md:mb-8 leading-tight text-white break-words">
      <span className="block">{title}</span>
      <span className="block bg-gradient-to-r from-cyan-400 via-blue-400 to-purple-400 bg-clip-text text-transparent pb-2">
        {titleHighlight}
      </span>
    </h1>
  );
};

export default HeroTitle;
